import classNames from 'classnames'
import Tooltip from 'components/common/Tooltip'
import { ReactNode, useState } from 'react'

interface HeaderButtonProps {
  handleClick: () => void
  children: ReactNode
  className?: string
  tooltipLabel?: string
  /** 'primary' = filled button (Commencer style); 'text' = text link (Connexion style) */
  variant?: 'primary' | 'text'
}

const HeaderButton = ({
  children,
  handleClick,
  className,
  tooltipLabel,
  variant = 'primary',
}: HeaderButtonProps) => {
  const [isHover, setIsHover] = useState(false)
  return (
    <div
      className="relative h-full flex items-center"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <button
        onClick={handleClick}
        className={classNames(
          'flex items-center transition-colors duration-200 outline-none focus:outline-none',
          variant === 'text'
            ? 'font-medium text-sm text-imovSecondary hover:text-imovSecondaryDark'
            : 'px-4 py-2 rounded-lg bg-imovPrimary text-imovWhite font-semibold text-sm hover:bg-imovPrimaryDark',
          className
        )}
      >
        <span className="flex">{children}</span>
      </button>
      {tooltipLabel && <Tooltip text={tooltipLabel} showTooltip={isHover} />}
    </div>
  )
}

export default HeaderButton
